var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SubSidebarLayout',{attrs:{"menu-categories":_vm.menuCategories}})}
var staticRenderFns = []

export { render, staticRenderFns }